import {
  WSActions,
  WSControlGroup,
  WSInfoBox,
  WSList
} from "@wingspanhq/fe-component-library";
import React from "react";
import { WS_LINKS } from "../../../../types/wsLinks";

type ValueType = "standard" | "insurance";

interface UploadDocumentModalProps {
  onClose(): void;
  onContinue(type: ValueType): void;
}

export const ModalSelectUploadDocument: React.FC<UploadDocumentModalProps> = ({
  onClose,
  onContinue
}) => {
  const [value, setValue] = React.useState<ValueType>("standard");

  return (
    <WSList gap="L">
      <WSInfoBox title="Document types">
        There are two (2) types of document upload, please select a method to
        continue. <br />
        <br />
        Reminder: Your files are encrypted and secured. However, “General
        documents” is not designed for storing sensitive payment information
        (such as payment card numbers). <br />
        <a href={WS_LINKS.security} target="_blank" rel="noopener noreferrer">
          Learn more
        </a>{" "}
        about data security.
      </WSInfoBox>

      <WSControlGroup
        type="radio"
        name="type"
        value={value}
        onChange={value => setValue(value as ValueType)}
        required
        size="M"
        chip
        options={[
          {
            label: "General document",
            helperText:
              "Images or files intended to be stored or shared as-is.",
            value: "standard"
          },
          {
            label: "Insurance document upload",
            helperText:
              "Certificates of Insurance (COI) or other proof of insurance documents. The insurance policies will be extracted and stored on your account and used to fulfill relevant client requirements.",
            value: "insurance"
          }
        ]}
      />

      <WSActions
        alignment="fill"
        buttons={[
          {
            kind: "Secondary",
            label: "Cancel",
            onClick: onClose,
            type: "button"
          },
          {
            disabled: !value,
            kind: "Primary",
            onClick: () => {
              onClose();
              onContinue(value);
            },
            label: "Continue"
          }
        ]}
      />
    </WSList>
  );
};
